var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlide2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.751 209.275H157.877C151.743 209.275 146.753 214.344 146.753 220.575C146.753 226.819 151.743 231.875 157.877 231.875H220.751C226.886 231.875 231.875 226.819 231.875 220.575C231.875 214.344 226.886 209.275 220.751 209.275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.829 76.2301L173.408 124.373C174.845 125.524 175.091 127.637 173.969 129.109L103.336 221.145C98.896 226.83 92.3527 230.047 85.342 230.166L46.7831 230.64C44.7266 230.664 42.9272 229.24 42.4598 227.198L33.6965 189.097C32.1775 182.094 33.6965 174.854 38.1366 169.275L109.12 76.7998C110.265 75.3161 112.38 75.055 113.829 76.2301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.081 95.6809L188.595 110.019C187.439 111.479 185.359 111.717 183.922 110.553C169.959 99.2536 134.204 70.2564 124.284 62.2208C122.835 61.0338 122.636 58.9211 123.805 57.4493L134.882 43.6925C144.93 30.7548 162.457 29.5678 176.595 40.8438L192.837 53.7816C199.497 59.0042 203.937 65.8885 205.456 73.1289C207.209 81.0933 205.339 88.9153 200.081 95.6809Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide-2.15149d8b6c277abbbd0c477010867564.svg";
export { ForwardRef as ReactComponent };